import { createContext, useContext, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { DEFAULT_REGION, PARAMS_FREE_PATHS, REGION_KEY } from 'shared/components/RegionSwitcher/constants';
import { setStoredRegion } from 'shared/components/RegionSwitcher/regionSessionStorage';
import { setCurrentRegion } from 'shared/components/RegionSwitcher/regionState';
import { isLoggedIn } from '@nordvpn/teams.core/lib/auth/utils/localStorage';
import { Features } from 'types/features/enums';
import { getPathWithRegion } from 'utils/routing/getPathWithRegion';
import { getRegionFromSearch } from 'utils/routing/getRegionFromSearch';
import { useFeatureFlag } from 'utils/useFeatureFlag';
import { jsx as _jsx } from "react/jsx-runtime";
var RegionContext = /*#__PURE__*/ createContext(DEFAULT_REGION);
export var RegionProvider = function RegionProvider(_ref) {
    var children = _ref.children;
    var location = useLocation();
    var history = useHistory();
    var retrievedRegion = getRegionFromSearch(location.search);
    var isMultiRegionEnabled = useFeatureFlag(Features.MultiRegionSwitcher);
    var region = isMultiRegionEnabled ? retrievedRegion : DEFAULT_REGION;
    setCurrentRegion(region);
    useEffect(function () {
        if (!isMultiRegionEnabled)
            return;
        setStoredRegion(region);
    }, [isMultiRegionEnabled, region]);
    useEffect(function () {
        if (!isMultiRegionEnabled)
            return;
        if (!isLoggedIn())
            return;
        if (PARAMS_FREE_PATHS.some(function (path) {
            return location.pathname.startsWith(path);
        }))
            return;
        var param = new URLSearchParams(location.search).get(REGION_KEY);
        if (param === region)
            return;
        history.replace(getPathWithRegion(location.pathname + location.search, region));
    }, [isMultiRegionEnabled, history, location.pathname, location.search, region]);
    return /*#__PURE__*/ _jsx(RegionContext.Provider, {
        value: region,
        children: children
    });
};
export var useRegion = function useRegion() {
    return useContext(RegionContext);
};
